module.exports = __webpack_public_path__ + "img/elli-logo.e237f9b2.svg";